export default "__VITE_ASSET__3yDX2Ux9__"